let config = ($mdThemingProvider) => {
  var sabinRed = $mdThemingProvider.extendPalette('red', {
    '900': 'b90a00'
  });

  var sabinWarn = $mdThemingProvider.extendPalette('red', {
    '500': '9e9e9e'
  });

  $mdThemingProvider.definePalette('sabinRed', sabinRed);
  $mdThemingProvider.definePalette('sabinWarn', sabinWarn);

  $mdThemingProvider
    .theme('default')
    .primaryPalette('blue')
    .accentPalette('sabinRed', {
      'default': '900'
    })
    .warnPalette('sabinWarn')
    .backgroundPalette('grey');

  $mdThemingProvider.theme('success-toast');
  $mdThemingProvider.theme('error-toast');
}

config.$inject = ['$mdThemingProvider'];

export default config;


// WEBPACK FOOTER //
// ./client/app/config/md-theming-provider-config.js